
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Focusable } from '@/shared/interfaces/focusable'
import { FormGroup } from '@/shared/forms/form-group'

@Component({
  inject: ['form'],
})
export default class UnifyTextarea extends Vue implements Focusable {
  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop({
    type: String,
  })
  public readonly placeholder!: string

  @Prop({
    type: String,
  })
  public readonly value!: string

  public readonly form!: FormGroup<any>

  public get controlValue() {
    return this.formControl.$model
  }

  public set controlValue(value: any) {
    this.formControl.$model = value
  }

  public get dirty() {
    return this.formControl.$dirty
  }

  public get error() {
    return this.dirty && this.invalid
  }

  public get formControl() {
    return this.form.field(this.control)
  }

  public get invalid() {
    return this.formControl.$invalid
  }

  public get required() {
    return this.formControl.hasOwnProperty('required')
  }

  public data() {
    return {
      model: this.value,
    }
  }

  public focus() {
    const textarea = this.$refs.textarea as HTMLTextAreaElement

    textarea.focus()
  }

  public update(event: InputEvent) {
    const target = event.target as HTMLTextAreaElement

    this.$emit('input', target.value)
  }
}
